import { ChangeDetectorRef, Component, forwardRef, ViewChild } from "@angular/core";
import { IonTextarea, TextareaCustomEvent } from "@ionic/angular";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Component({
	selector: "app-comment",
	templateUrl: "./comment.component.html",
	styleUrls: ["./comment.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CommentComponent),
			multi: true,
		},
	],
})
export class CommentComponent implements ControlValueAccessor {
	constructor(
		private rideOpsUi: RideOpsUiService,
		private changeDetector: ChangeDetectorRef,
	) {}

	@ViewChild(IonTextarea) private textarea?: IonTextarea;

	showComment = false;
	commentModel = "";

	isV2 = (): boolean => this.rideOpsUi.isV2Active();

	activateComment = async () => {
		this.showComment = true;
		this.changeDetector.detectChanges();
		await this.textarea?.setFocus();
		const native = await this.textarea?.getInputElement();
		if (!native) {
			return;
		}
		const end = native.value?.length ?? 0;
		native.setSelectionRange(end, end);
	};

	onCommentChange = (event: Event) => {
		const value = (<TextareaCustomEvent>event).target.value;
		this.onTouched();
		this.onChange(value);
	};

	onChange = (_comment: string) => {};
	onTouched = () => {};
	disabled = false;

	writeValue(obj: string): void {
		this.commentModel = obj;
		this.showComment = this.commentModel?.length > 0;
	}

	registerOnChange(fn: (value: string) => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
}
